'use strict';

// 調整履歴アコーディオン（リーグ詳細画面）
$(document).on('click', '.js-adjustment-history-toggle', function () {
  const $content = $(this).next('.js-adjustment-history-content');
  const isVisible = $content.is(':visible');
  $content.slideToggle(200);

  const $icon = $(this).find('i');
  const $text = $(this).find('.js-adjustment-history-text');
  if (isVisible) {
    $icon.removeClass('fa-caret-down').addClass('fa-caret-right');
    $text.text($(this).data('open-text'));
  } else {
    $icon.removeClass('fa-caret-right').addClass('fa-caret-down');
    $text.text($(this).data('close-text'));
  }
});
